(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.cardsPerView = parseInt(this.dataset.cardsDesktop) || 3;
      this.cardsPerViewTablet = parseInt(this.dataset.cardsTablet) || 2;
    }

    connectedCallback() {
      this.track = this.querySelector('.testimonials-slider__track');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.cards = this.querySelectorAll('.testimonials-slider__card');
      this.totalCards = this.cards.length;

      if (this.totalCards === 0) return;

      this.updateCardsPerView();
      this.setupEventListeners();
      this.updateButtons();

      window.addEventListener('resize', () => {
        this.updateCardsPerView();
        this.updateSlider();
      });
    }

    updateCardsPerView() {
      if (window.innerWidth <= 749) {
        this.activeCardsPerView = 1;
      } else if (window.innerWidth <= 989) {
        this.activeCardsPerView = this.cardsPerViewTablet;
      } else {
        this.activeCardsPerView = this.cardsPerView;
      }

      const maxIndex = Math.max(0, this.totalCards - this.activeCardsPerView);
      if (this.currentIndex > maxIndex) {
        this.currentIndex = maxIndex;
      }
    }

    setupEventListeners() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      let startX = 0;
      let currentX = 0;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });

      this.track.addEventListener('touchmove', (e) => {
        currentX = e.touches[0].clientX;
      }, { passive: true });

      this.track.addEventListener('touchend', () => {
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
      });
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateSlider();
      }
    }

    next() {
      if (this.currentIndex < this.totalCards - this.activeCardsPerView) {
        this.currentIndex++;
        this.updateSlider();
      }
    }

    updateSlider() {
      const card = this.cards[0];
      if (!card) return;

      const cardWidth = card.offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.currentIndex * (cardWidth + gap));

      this.track.style.transform = `translateX(${offset}px)`;
      this.updateButtons();
    }

    updateButtons() {
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex >= this.totalCards - this.activeCardsPerView;
      }
    }
  }

  customElements.define('testimonials-carousel', TestimonialsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
